import {useState} from 'react';
import Loginbonus from "./Loginbonus";
import StorePage from "./StorePage";
import Recharge from "./Recharge";
import config from "../config";
import CobBucks from "./CobBucks"

function StarGamepage({initialView}) {
    const [view, setView] = useState(initialView);
    //const [consecutiveDays, setConsecutiveDays] = useState(0);
    const handleClick=(e)=>setView(e.target.id);
    //const incrementConsecutiveDays=(e)=>{
        //handle case where consecutive days = 7
       // setConsecutiveDays(consecutiveDays+1);
       // setView('game');
    //}
    const progressWidth=()=>{
        var days = localStorage.getItem("consecutiveDays")
        if (days === null){
            return 0 + '%'
        }
        else {
            return (days/7)*100 + '%'
        }
    }

    var brass = localStorage.getItem("Brass")
    var silver = localStorage.getItem("Silver")
    var gold = localStorage.getItem("Gold")

    if(brass === null) {
        brass = 0
    }
    if(silver === null) {
        silver = 0
    }
    if(gold === null) {
        gold = 0
    }

    config.CobBucks[0].amount = brass;
    config.CobBucks[1].amount = silver;
    config.CobBucks[2].amount = gold;
    let CobEls = [];
    for (let mybucks of config.CobBucks) {
      CobEls.push(
        <CobBucks
          name={mybucks.name}
          amount={mybucks.amount}
          image={mybucks.image}
          id={mybucks.id}
        />
      );
    }

    return(
        <div className="homepage-bgimage">  
            <div style={{ display: "flex", flexDirection: "column", height: "calc(100% - 24px)", paddingTop: "24px" }}>
                <div className="buttons">
                    <button id='game' type="button" onClick={handleClick}>
                        Game
                    </button>
                    <button id='loginbonus' type="button" onClick={handleClick}>
                        Login Bonus
                    </button>
                    <button id='store' type="button" onClick={handleClick}>
                        Store
                    </button>
                    <button id='recharge' type="button" onClick={handleClick}>
                        Recharge
                    </button>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '100%'}}>
                    
                    {
                        view === 'game' ?
                        (<iframe title='game'
                            src="https://tundeszirak.github.io/hangman/" 
                            style={{ flexGrow: 1 }}>
                            
                        </iframe>) :
                        view === 'loginbonus' ?
                        
                        <Loginbonus  />
                        
                        :

                        view === 'store' ?
                        <StorePage />
                        :
                        <Recharge />
                        
                    }
                    
                        <div className="Bucks">
                            {CobEls}
                        </div>
                    
                        <div>
                            <span>Login Bonus</span>
                            <div className="progress">
                                <div className="progress-bar" role="progressbar" 
                                style={{width: progressWidth()}} aria-valuenow="25" aria-valuemin="0" 
                                aria-valuemax="100"></div>
                            </div>
                            <span>Login 7 days to unlock dark mode!</span>
                        </div>
                    </div>
                </div>
        </div>
    );
}

export default StarGamepage;